import {UrlObj} from "./other/UrlObj";
import {ServerService} from "../services/server.service";
import {Injectable} from "@angular/core";
import {DataService} from "../services/data.service";
import moment from "moment/moment";
import {ProdottoVarianteIstanza} from "./ProdottoVarianteIstanza";
import {PianoFeature} from "./PianoFeature";


@Injectable({
   providedIn: 'root'
})
export class PianoFactory {

   constructor(private serverSrv: ServerService,
               private dataSrv: DataService) {
   }

   async getPiani(vendorSlug=null, type=''):Promise<Piano[]> {
      let url = '/api/piani'
      if (vendorSlug) url = `/api/esercizi/${vendorSlug}/piani?type=${type}`
      return new Promise<Piano[]>((resolve, reject) => {
         ServerService.instance.getAll(Piano, url).then(piani=>{
            resolve(piani)
         }).catch(err=>{
            reject(err)
         })
      })
   }
}

export class PianoData {
   id?: number;
   features?:any;
   ext_id?: number;
   nome?:string;
   descrizione?:string;
   inizio?:string;
   is_active?:boolean;
   is_free?:boolean;
   is_demo?:boolean;
   visible?:boolean;
   index?:number;
   prezzo_mensile?:number;
   prezzo_annuale?:number;
}

export class Piano {

   data:PianoData = {}

   constructor(data:PianoData) {
      // assegno al mio oggetto data (è un json)
      if(!data) data = {}
      Object.assign(this.data, data)

      // if(!data.features)
      //    this.data.features = new PianoFeature({});
      // else
      //    this.data.features = new PianoFeature(data.features);
   }

   public static BASE_URL(path=null, queryParams={}):string{
      let url:UrlObj = new UrlObj(`/api/piani`, queryParams);
      if(path) url.url += path;
      return url.toString()
   }

   public static SeverityChoices = {
      'INFO': 1,
      'WARNING': 2,
      'ERROR': 3,
      'SUCCESS': 3,
   }

}


